import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getAppointment } from 'src/api/quote';
import { setAppointment } from 'src/store/actions';
import { Payment } from '@material-ui/icons';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import QuotePaymentStepper from './QuotePaymentStepper';

const promise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY || '');

const QuoteServicePayment: React.FC = (): ReactElement => {
  const { appId: appIdParam }: { appId: string } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const asyncReadAppointment = async () => {
      const appointment = await getAppointment(appIdParam);

      dispatch(setAppointment(appointment.data));
    };

    if (appIdParam) {
      asyncReadAppointment();
    }
  }, [appIdParam, dispatch]);

  const steps = [
    {
      id: 1,
      label: 'Payment',
      image: <Payment />,
    },
  ];

  return (
    <Elements
      stripe={promise}
      options={{
        appearance: {
          theme: 'stripe',
          variables: {
            colorPrimaryText: '#005959',
            colorPrimary: '#005959',
            colorBackground: '#ffffff',
            colorDanger: '#ff0000',
            spacingUnit: '2px',
            borderRadius: '4px',
          },
        },
      }}
    >
      <QuotePaymentStepper steps={steps} />
    </Elements>
  );
};

export default QuoteServicePayment;
